<template>
    <v-container class="pt-0">
        <div>
            <!-- BILLING HEADING -->
            <h2 class="mb-0">
                <TranslatableStringComponent :tstring="{string: 'cardDetails'}" />
            </h2>
            <span>
                <div
                    class="payment-note mt-1"
                    :style="[
                        $vuetify.breakpoint.xs
                            ? {
                                  'font-size': '0.68em',
                              }
                            : {
                                  'font-size': '0.75em',
                              },
                    ]"
                >
                    <span>* <TranslatableStringComponent :tstring="{string: 'cardWillNotBeCharged'}" /></span>
                </div>
            </span>
        </div>
        <v-row>
            <v-col cols="12">
                <!-- CARD HOLDER NAME -->
                <ValidationProvider
                    name="cardHolder"
                    rules=""
                    class="validationWrapper"
                >
                    <div slot-scope="{ errors }">
                        <span class="validationMessage">
                            {{ errors[0] }}
                        </span>
                        <v-text-field
                            id="cardHolder"
                            v-model="cardHolder"
                            name="cardHolder"
                            :label="localize('cardHolderName')"
                            hide-details="false"
                            outlined
                            dense
                        ></v-text-field>
                    </div>
                </ValidationProvider>
            </v-col>
            <v-col cols="12">
                <!-- CARD NUMBER -->
                <ValidationProvider
                    name="cardNumber"
                    rules=""
                    class="validationWrapper"
                >
                    <div slot-scope="{ errors }">
                        <span class="validationMessage">
                            {{ errors[0] }}
                        </span>
                        <v-text-field
                            id="cardNumber"
                            v-model="cardNumber"
                            v-mask="maskCreditCardNumber"
                            name="cardNumber"
                            :label="localize('cardNumber')"
                            hide-details="false"
                            outlined
                            dense
                            append-inner-icon="faCcVisa"
                        ></v-text-field>
                    </div>
                </ValidationProvider>
            </v-col>
            <v-col cols="8">
                <!-- EXPIRY DATE -->
                <ValidationProvider
                    name="expiryDate"
                    rules=""
                    class="validationWrapper"
                >
                    <div slot-scope="{ errors }">
                        <span class="validationMessage">
                            {{ errors[0] }}
                        </span>
                        <v-text-field
                            id="expiryDate"
                            v-model="expiryDate"
                            v-mask="maskExpiryDate"
                            name="billingCity"
                            :label="localize('expDate')"
                            outlined
                            hide-details="false"
                            dense
                        ></v-text-field>
                    </div>
                </ValidationProvider>
            </v-col>
            <v-col cols="4">
                <!-- CVV -->
                <ValidationProvider
                    name="cvc"
                    rules=""
                    class="validationWrapper"
                >
                    <div slot-scope="{ errors }">
                        <span class="validationMessage">
                            {{ errors[0] }}
                        </span>
                        <v-text-field
                            id="cvc"
                            v-model="cvc"
                            v-mask="maskCvc"
                            :label="localize('cvv')"
                            hide-details="false"
                            outlined
                            dense
                        ></v-text-field>
                    </div>
                </ValidationProvider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { createHelpers } from 'vuex-map-fields'
import { mapGetters, mapState } from 'vuex'
import { mask } from 'vue-the-mask'
const { mapFields } = createHelpers({
    getterType: 'getCreditCardFormField',
    mutationType: 'updateCreditCardFormField',
})
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'CreditCardForm',
    components: { ValidationProvider, ValidationObserver, TranslatableStringComponent },
    directives: { mask },
    props: {},
    data() {
        return {
            maskCreditCardNumber: '',
            maskDefaultCreditCardNumber: '#### #### #### ####',
            maskAmexCreditCardNumber: '#### ###### #####',
            cardLength: 19,
            maskExpiryDate: '## / ##',
        }
    },
    computed: {
        ...mapState('auth', ['webUser']),
        ...mapGetters({
            isLoggedIn: 'auth/isLoggedIn',
        }),
        ...mapFields('paymentGateway', [
            'cardHolder',
            'cardNumber',
            'expiryDate',
            'cvc',
        ]),
        maskCvc() {
            const firstDigit = this.cardNumber.split('')[0]
            if (
                firstDigit === '6' ||
                firstDigit === '5' ||
                firstDigit === '4'
            ) {
                return '###'
            } else if (firstDigit === '3') {
                return '####'
            } else {
                return '###'
            }
        },
    },
    watch: {
        cardNumber: {
            handler(newVAl, oldVal) {
                // regex test for Amex card
                // NOTE : American Express card numbers start with 34 or 37 and have 15 digits
                const re = new RegExp('^3[47]')
                if (newVAl.match(re) != null) {
                    this.maskCreditCardNumber = this.maskAmexCreditCardNumber
                    this.cardLength = 17
                } else {
                    this.maskCreditCardNumber = this.maskDefaultCreditCardNumber
                    this.cardLength = 19
                }
            },
            deep: true,
        },
        isCustomerCreated(newValue, oldValue) {
            if (!newValue) {
                this.routerPush({ type: 'page', slugName: 'customer-details' })
            }
        },
    },
    mounted() {},
    methods: {
        isNumber(evt) {
            evt = evt || window.event
            const charCode = evt.which ? evt.which : evt.keyCode
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault()
            } else {
                return true
            }
        },
    },
}
</script>

<style></style>
